import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ngx-card-no-name',
  template: `
  <router-outlet></router-outlet>
`,
})

export class CardNoNameComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
